export default __webpack_public_path__ + "static/media/icn_motion_fitness.e1e11692.svg";